import {FormControl} from '@angular/forms';

export function notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
  return value !== null && value !== undefined;
}

export function notNull<TValue>(value: TValue | null | undefined): TValue {
  if (value === null || value === undefined) {
    throw new Error('Unexpected null');
  }
  return value;
}

export function phoneNumberValidator(control: FormControl): null | {[key: string]: boolean} {
  if (control.value && control.value.length > 15) {
    return {tooLong: true};
  } else if (control.value && control.value.length < 8) {
    return {tooShort: true};
  }
  return null;
}

export enum UserAgent {
  ANDROID = 'Android',
  IOS = 'iOS',
  UNKNOWN = 'unknown',
}

export function detectUserAgent(): UserAgent {
  const userAgent = navigator.userAgent || navigator.vendor;

  if (/android/i.test(userAgent)) {
    return UserAgent.ANDROID;
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return UserAgent.IOS;
  }

  return UserAgent.UNKNOWN;
}
